import React, { RefObject } from 'react'

type ProductContext = {
    reviewsRef: null | RefObject<HTMLDivElement>
}
const DefaultProductContext: ProductContext = {
    reviewsRef: null,
}

export const ProductContext = React.createContext(DefaultProductContext)
